module.exports = __webpack_public_path__ + "static/img/jsldBanner@2x.7e2b37e4.png";